import { z } from 'zod'
import { oc } from '@orpc/contract'

export const createOrganizationConnect = oc
  .route({ method: 'POST', path: '/v2/organizations/connects' })
  .input(
    z.object({
      recipientEmail: z.email(),
    }),
  )
  .output(
    z.object({
      id: z.string(),
      acceptUrl: z.string(),
      status: z.literal('pending'),
      createdAt: z.string(),
    }),
  )
